/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { isEmpty } from 'lodash'

import type { Cluster } from '@modules/ccm-api/v1/types'
import type { CCMCluster } from '@modules/ccm-components/ClusterTable'

import { getCCMServices } from './feature'

import type { CCMService } from './types'

type ServiceName = keyof Cluster['services']

export function adaptFromWebAPI(data: { items: Cluster[] } | undefined): CCMCluster[] {
  return (
    data?.items.map<CCMCluster>((cluster: Cluster) => ({
      id: cluster.id,
      name: isEmpty(cluster.name) ? undefined : cluster.name,
      services: Object.entries(cluster.services)
        .filter(([, config]) => config.enabled)
        .map(([serviceName]) => getServiceName(serviceName as ServiceName)),
    })) ?? []
  )
}

export function getServiceName(serviceName: ServiceName): CCMService {
  const services = getCCMServices()

  if (services.includes(serviceName as CCMService)) {
    return serviceName as CCMService
  }

  throw new Error(`Unknown CCM service: ${serviceName}`)
}
